<template>
	<div class="d-flex j-center a-center">
		<div class="content-box">
			<div>
				<div style="font-weight: 700;font-size: 16px;margin-top: 22px;display: flex;">
					<div @click="curindex = 0" :style="curindex==0?'':'color:#888888'" style="cursor: pointer;">修改密码</div>
					<div @click="curindex = 1" :style="curindex==1?'':'color:#888888'" style="margin-left: 48px;cursor: pointer;">更换绑定手机号</div>
				</div>
				<template v-if="curindex == 0">
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">登录账号：</div>
						<el-input v-model="user_name" maxlength="11" style="width: 220px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">验证码 ：</div>
						<el-input v-model="code" maxlength="11" style="width: 220px;" size="small" placeholder="输入验证码">
							<template slot="append">
								<el-button :disabled="disabled" @click="getCode">{{countdown}}</el-button> 
							</template>
						</el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">新密码 ：</div>
						<el-input v-model="pass" maxlength="11" style="width: 220px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">确认密码 ：</div>
						<el-input v-model="newPass" maxlength="11" style="width: 220px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex" style="margin-top: 25px;">
						<div @click="resetPass" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
						border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: auto;">
							确定修改
						</div>
					</div>
				</template>
				<template v-else>
					<div style="width: 276px;color: #BBBBBB;font-size: 12px;margin-top: 25px;">
						更换手机号码后，下次登录需使用新号码登录。当前
						手机号码：{{curMobile}}
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">新手机号：</div>
						<el-input v-model="new_mobile" maxlength="11" style="width: 220px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">验证码 ：</div>
						<el-input v-model="sms_code" maxlength="11" style="width: 220px;" size="small" placeholder="输入验证码">
							<template slot="append">
								<el-button :disabled="disabled1" @click="getCode1">{{countdown1}}</el-button> 
							</template>
						</el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;margin-top: 25px;color: #BBBBBB;">
						<div style="width: 100px;">密码验证 ：</div>
						<el-input v-model="password"  style="width: 220px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex" style="margin-top: 25px;">
						<div @click="login_mobile_modify" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
						border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: auto;">
							确定更换
						</div>
					</div>
				</template>
				
				
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				user_name:'',
				countdown: '获取验证码',
				countdown1:'获取验证码',
				code: '',
				mobile: '',
				pass:'',
				newPass:'',
				disabled: false,
				disabled1: false,
				timestatus: false,
				timestatus1: false,
				clear: '',
				clear1: '',
				curindex:0,
				curMobile:'',
				new_mobile:'',
				sms_code:'',
				password:''
			}
		},
		created() {
			this.user_name = JSON.parse(localStorage.getItem('user_info')).user_name
			this.curMobile = JSON.parse(localStorage.getItem('user_info')).user_name
		},
		methods:{
			// 获取验证码
			getCode() {
				if (this.user_name == '') {
					this.$message({
						showClose: false,
						message: '请输入手机号码',
						type: 'error',
						offset: 350
					})
				} else if (!(/^1(3|4|5|6|7|8|9|)\d{9}$/.test(this.user_name))) {
					this.$message({
						showClose: false,
						message: '手机号码不正确',
						type: 'error',
						offset: 350
					})
				} else {
					this.disabled = true; //禁用点击
					let params = {
						app_key:'FE511BED-AF67-4F97-90D7-2B6CF7899214',
						method:'dsc.user.mobile_code.post',
						mobile:this.user_name
					}				
					this.$api.getMobileCode(params).then((res)=>{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350
						})
						if (res.code == 0) {
							this.countdown = 180;
							this.timestatus = true;
							this.clear = setInterval(this.countDown, 1000);
						} else {
							this.disabled = false; //获取失败开启点击
						}
					})
				}
			},
			getCode1() {
				if (this.new_mobile == '') {
					this.$message({
						showClose: false,
						message: '请输入手机号码',
						type: 'error',
						offset: 350
					})
				} else if (!(/^1(3|4|5|6|7|8|9|)\d{9}$/.test(this.new_mobile))) {
					this.$message({
						showClose: false,
						message: '手机号码不正确',
						type: 'error',
						offset: 350
					})
				} else {
					this.disabled1 = true; //禁用点击
					let params = {
						app_key:'FE511BED-AF67-4F97-90D7-2B6CF7899214',
						method:'dsc.user.mobile_code.post',
						mobile:this.new_mobile
					}				
					this.$api.getMobileCode(params).then((res)=>{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350
						})
						if (res.code == 0) {
							this.countdown1 = 180;
							this.timestatus1 = true;
							this.clear = setInterval(this.countDown1, 1000);
						} else {
							this.disabled1 = false; //获取失败开启点击
						}
					})
				}
			},
			countDown1() {
				if (!this.countdown) {
					this.disabled1 = false;
					this.timestatus1 = false;
					this.countdown1 = '获取验证码';
					clearInterval(this.clear1);
				} else {
					--this.countdown1;
				}
			},
			// 倒计时
			countDown() {
				if (!this.countdown) {
					this.disabled = false;
					this.timestatus = false;
					this.countdown = '获取验证码';
					clearInterval(this.clear);
				} else {
					--this.countdown;
				}
			},
			//修改密码
			resetPass(){
				
				if (this.user_name == '') {
					this.$message({
						showClose: false,
						message: '请输入手机号码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (!(/^1(3|4|5|6|7|8|9|)\d{9}$/.test(this.user_name))) {
					this.$message({
						showClose: false,
						message: '手机号码错误',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.code == ''){
					this.$message({
						showClose: false,
						message: '请输入验证码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.pass == ''){
					this.$message({
						showClose: false,
						message: '请输入新密码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.newPass == ''){
					this.$message({
						showClose: false,
						message: '请输入确认密码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.newPass != this.pass){
					this.$message({
						showClose: false,
						message: '两次密码不一致',
						type: 'error',
						offset: 350
					})
					return
				}
				
				
				let params = {
					act: 'change_pwd',
					type: 1,
					mobile: this.user_name,
					code: this.code,
					password: this.pass
				}				
				this.$api.resetPass(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '修改成功',
							type: 'success',
							offset: 350
						})
						setTimeout(()=>{
							localStorage.removeItem('token')
							localStorage.removeItem('user_info')
							localStorage.removeItem('user_id')
							this.$router.push('/Login')
						},1000)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			
			login_mobile_modify(){
				
				if (this.new_mobile == '') {
					this.$message({
						showClose: false,
						message: '请输入手机号码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (!(/^1(3|4|5|6|7|8|9|)\d{9}$/.test(this.new_mobile))) {
					this.$message({
						showClose: false,
						message: '手机号码错误',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.sms_code == ''){
					this.$message({
						showClose: false,
						message: '请输入验证码',
						type: 'error',
						offset: 350
					})
					return
				}
				if (this.password == ''){
					this.$message({
						showClose: false,
						message: '请输入密码验证',
						type: 'error',
						offset: 350
					})
					return
				}
				
				
				let params = {
					act: 'login_mobile_modify',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					sms_code: this.sms_code,
					new_mobile: this.new_mobile,
					password: this.password
				}				
				this.$api.login_mobile_modify(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '修改成功，请重新登录',
							type: 'success',
							offset: 350
						})
						setTimeout(()=>{
							localStorage.removeItem('token')
							localStorage.removeItem('user_info')
							localStorage.removeItem('user_id')
							this.$router.push('/Login')
						},1500)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.content-box{
		width: 1170px;
		min-height: 730px;
		border-radius: 6px;
		background: #FFFFFF;
		box-sizing: border-box;
		margin-top: 25px;
		padding: 24px;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
